import { render, staticRenderFns } from "./Diversity.vue?vue&type=template&id=f39cbc8a&scoped=true"
import script from "./Diversity.vue?vue&type=script&lang=js"
export * from "./Diversity.vue?vue&type=script&lang=js"
import style0 from "./Diversity.vue?vue&type=style&index=0&id=f39cbc8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39cbc8a",
  null
  
)

export default component.exports